import { toDollarFormat } from '@mixins/formattable'
import { formatDate } from '@/utils'

const CARD_TYPES = {
  '001': 'Visa',
  '002': 'Mastercard',
  '003': 'American Express',
  '004': 'Discover'
}

const DEFAULT_CARD_TYPE_DISPLAY = 'Credit'

export default {
  singleInvoice:
    state => state.singleInvoice,
  singleInvoiceLoading:
    state => state.singleInvoiceLoading,

  // Payment History by payment ID for payment confirmation page
  paymentHistory: state => {
    if(state.paymentHistory && Array.isArray(state.paymentHistory)) {
      return state.paymentHistory.map(ph => {
        ph.displayPaidAmount = toDollarFormat(ph.paidAmt)
        ph.invoiceDate = ph.invoiceType === 'EI1' ? ph.billMonth : ph.invoiceDate
        return ph;
      });
    }
    return [];
  },
  paymentHistoryLoading:
    state => state.paymentHistoryLoading,

  // Payment History
  invoicePaymentHistory: state => {
    if(state.invoicePaymentHistory && Array.isArray(state.invoicePaymentHistory)) {
      return state.invoicePaymentHistory.map((invoicePaymentHistory) => {
        invoicePaymentHistory.displayInvoiceAmount = toDollarFormat(invoicePaymentHistory.invoiceAmount)
        invoicePaymentHistory.displayOpenAmount = toDollarFormat(invoicePaymentHistory.openAmount)
        invoicePaymentHistory.displayAdjustments = toDollarFormat(invoicePaymentHistory.adjustmentAmount)
        invoicePaymentHistory.displayPaidAmount = toDollarFormat(invoicePaymentHistory.paidAmount)
        invoicePaymentHistory.group = `${invoicePaymentHistory.groupName} - ${invoicePaymentHistory.groupId}`
        invoicePaymentHistory.subGroup = `${invoicePaymentHistory.subGroupName} - ${invoicePaymentHistory.subGroupId}`
        invoicePaymentHistory.paidDate = formatDate(invoicePaymentHistory.paidDate)
        //invoicePaymentHistory.displayInvoiceDate = formatDate(invoicePaymentHistory.invoiceDate, 'MMM YYYY')
        invoicePaymentHistory.displayInvoiceDate = formatDate(invoicePaymentHistory.invoiceDate)
        return invoicePaymentHistory;
      });
    }
    return [];
  },
  invoicePaymentHistoryLoading:
    state => state.invoicePaymentHistoryLoading,
  invoicePaymentHistoryUserMessage:
    state => state.invoicePaymentHistoryUserMessage,

  paymentMethods:
    state => state.paymentMethods,
  paymentMethodsLoading:
    state => state.paymentMethodsLoading,
  recurringPaymentsForm:
    state => state.recurringPaymentsForm,
  invoices: state => {
    if(state.invoices) {
      return state.invoices.map(invoice => {
        invoice.displayInvoiceAmount = toDollarFormat(invoice.invoiceAmount)
        invoice.displayBalance = toDollarFormat(invoice.openAmount)
        invoice.group = `${invoice.groupName} - ${invoice.groupId}`
        invoice.subGroup = `${invoice.subGroupName} - ${invoice.subGroupId}`
        invoice.paidDate = formatDate(invoice.paidDate)
        invoice.displayPaidAmount = toDollarFormat(invoice.paidAmount)
        invoice.displayAdjustmentAmount = toDollarFormat(invoice.adjustmentAmount)
        invoice.displayInvoiceDate = formatDate(invoice.invoiceDate, 'MMM YYYY')
        invoice.lobId = invoice.lobId
        return invoice
      })
    }
    else {
      return [];
    }
  },
  filteredInvoices: state => {
    return state.filteredInvoices || [];
  },
  paymentInvoices: (state, getters) => {
    let nonPaymentStatuses = ['CREDIT']
    return getters.invoices.filter(invoice => {
      return !nonPaymentStatuses.includes(invoice.paymentStatus) && state.paymentLobs.includes(invoice.lobId)
    })
  },
  invoicesLoading:
    state => state.invoicesLoading,
  invoicesUserMessage:
    state => state.invoicesUserMessage,
  isBlocking:
    state => state.isBlocking,
  isUnBlocking:
    state => state.isUnBlocking,
  cybersourceDetails:
    state => state.cybersourceDetails || {},
  cybersourceDetailsLoading:
    state => state.cybersourceDetailsLoading || false,
  autoPayDetails:
    state => state.autoPayDetails,
  autoPayDetailsLoading:
    state => state.autoPayDetailsLoading,
  // userPaymentMethods:
  //   state => state.userPaymentMethods,
  userPaymentMethodsLoading:
    state => state.userPaymentMethodsLoading,
  userPaymentMethods: state => {
    let paymentMethods = state.userPaymentMethods
    if (!paymentMethods || !Array.isArray(paymentMethods)) return null
    paymentMethods.map(method => {
      if (method.paymentMethodID) {
        method.paymentMethodId = method.paymentMethodID
      }
      if (method.lastFour) {
        method.displayAccountNumber = 'xxxx' + method.lastFour
      } else {
        method.displayAccountNumber = method.accountNumber
      }
      if (method.cardType) {
        let displayCardType = CARD_TYPES[method.cardType] != null ? CARD_TYPES[method.cardType] : DEFAULT_CARD_TYPE_DISPLAY
        method.displayPaymentType = displayCardType
      } else {
        method.displayPaymentType = method.paymentType
      }
    })
    return paymentMethods
  },
  hasUserPaymentMethods: state => {
    return Array.isArray(state.userPaymentMethods) && state.userPaymentMethods.length > 0
  },
  userPaymentMethodsByLob: (state, getters) => {
    return getters.lobId ? state.userPaymentMethods.filter(x => x.lobId == getters.lobId) : state.userPaymentMethods
  },
  hasUserPaymentMethodsByLob: (state, getters) => {
    return Array.isArray(getters.userPaymentMethodsByLob) && getters.userPaymentMethodsByLob.length > 0
  },
  // TODO - review blind changes - remove currentPaymentMethod all together?
  currentPaymentMethod: state => {
    let currentPaymentMethod = state.currentPaymentMethod
    if (currentPaymentMethod.lastFour) {
      currentPaymentMethod.displayAccountNumber = 'xxxx' + currentPaymentMethod.lastFour
    } else {
      currentPaymentMethod.displayAccountNumber = currentPaymentMethod.accountNumber
    }
    if (currentPaymentMethod.cardType) {
      currentPaymentMethod.displayPaymentType = currentPaymentMethod.cardType
    } else {
      currentPaymentMethod.displayPaymentType = currentPaymentMethod.paymentType
    }

    return currentPaymentMethod
  },
  makingPayment:
    state => state.makingPayment,
  payment:
    state => state.payment,
  onetimePaymentDetails:
    state => state.onetimePaymentDetails,
  subGroupDetailsLoading:
    state => state.subGroupDetailsLoading,
  subGroupDetails:
    state => state.subGroupDetails,
  paymentLobs:
    state => state.paymentLobs,
  paymentsAvailable: (state) => {
    if (!state.invoices) return []
    return state.invoices.some(i => i.lobId !== null && state.paymentLobs.includes(i.lobId))
  },
  paymentsAvailableForSubGroup: (state) => {
    return (
      state.subGroupDetails &&
      state.subGroupDetails.subGroups &&
      state.subGroupDetails.subGroups[0] &&
      state.subGroupDetails.subGroups[0].paymentsAvailable
    )
  },
  cashOnAccountsLoading:
    state => state.cashOnAccountsLoading,
  lobId: (state) => {
    if (
      state.subGroupDetails &&
      state.subGroupDetails.subGroups &&
      state.subGroupDetails.subGroups[0]
    ) {
      return state.subGroupDetails.subGroups[0].lobId
    }
  },
  currentBalanceDue: (state) => {
    let balance = state.filteredInvoices.reduce((sum, invoice) => {
      return sum + ((!invoice.block && invoice.openAmount) || 0.0)
    }, 0.0)
    return balance
  },
  lastPaymentMade: (state) => {
    if(state.paymentHistory && Array.isArray(state.paymentHistory)) {
      return state.paymentHistory.sort((a, b) => {
        return new Date(b.paymentDate) - new Date(a.paymentDate)
      }).reverse()[0]
    }
    return null;
  },
  autoPayEnabled: (state) => {
    if(state.currentPaymentMethod) {
      return ['Y', 'y', true].includes(state.currentPaymentMethod.autoPayInd);
    }
    return false;
  },
  paymentHistoryConfigurationLoading:
    state => state.paymentHistoryConfigurationLoading,
  paymentHistoryEnabled:
    state => state.paymentHistoryEnabled,
  deletingUserPaymentMethod:
    state => state.deletingUserPaymentMethod,
  updateDefaultPaymentMethodLoading:
    state => state.updateDefaultPaymentMethodLoading
}
